'use client';

import React from 'react';
import { MoneyPageTemplate } from '@benzinga/money';
import { Offerings } from '@benzinga/alternative-investments';
import { Breadcrumbs, SectionTitle } from '@benzinga/core-ui';
import { SessionContext } from '@benzinga/session-context';
import { AltOfferingsManager } from '@benzinga/alts-manager';
import type { AltTypeProps } from '../getAltTypeProps';
import { OFFERING_TYPES } from '../offeringTypes';

export function AltTypePageContent({ allowFilter, offerings, page, type }: AltTypeProps) {
  const session = React.useContext(SessionContext);

  const tabs = React.useMemo(
    () => [
      { key: `/alternative-investments/${type}`, name: OFFERING_TYPES[type]?.asset_type },
      { key: `/alternative-investments/${type}/news`, name: 'News' },
    ],
    [type],
  );

  if (!offerings) return null;

  const offeringsManager = session.getManager(AltOfferingsManager);
  offeringsManager.addOfferings(offerings);

  return (
    <div className="min-h-screen">
      <div className="offerings-page-layout w-full">
        <MoneyPageTemplate
          layoutBelowArticle={
            <div className="explore-offerings-section pt-8" id="explore-offerings-section">
              <div className="section-title-container flex items-center justify-between border-b border-bzblue-400 pb-3 mb-6">
                <SectionTitle level={2}>Explore Offerings</SectionTitle>
              </div>
              <Offerings
                allOfferings={offerings}
                allowFilter={allowFilter}
                hidePropertyType={OFFERING_TYPES[type]?.hide_property_type}
                hideTargetReturn={OFFERING_TYPES[type]?.hide_target_return}
              />
            </div>
          }
          layoutHeader={
            <div className="w-full pt-4 px-2">
              <div className="offering-header-container mx-auto max-w-[1400px] w-full">
                <Breadcrumbs data={page?.breadcrumbs || []} />
              </div>
            </div>
          }
          layoutTabs={tabs}
          layoutTabsOptions={{ prefetchAllTabs: true }}
          post={page}
          tabsTitle={page?.title}
          width="wide"
        />
      </div>
    </div>
  );
}
